// 菜单
export default {
    groundStationSetting: 'Ground Station Setting',
    parameterSet: 'Parameter Setting',
    deviceManagement: 'Device Management',
    sharingManagement: 'Sharing Management',
    historyPlayback: 'History Playback',
    flightRecords: 'Flight Records',
    historicalRecords: 'Historical Records',
    videoRecords: 'Video Records',
    photoRecords: 'Photo Records',
    lpr: 'LPR',
    inspectionRecord: 'Inspection Record',
    mobileSpectrumRecord: 'Cell phone spectrum records',
    lifeDetectionRecord: 'Life detection record',
    flightRecordDetails: 'Inspection record details',
    enterpriseUsers: 'Enterprise Users',
    lifeStatistics: 'Life statistics',
    flightRecordPlayback: 'Flight record playback',
    details_uav: 'Equipment Details (UAV)',
    details_PTZ: 'Equipment Details (PTZ)',
    details_battery: 'Device Details (Smart battery)',
    details_rtk: 'Equipment Details (RTK)',
    details_simulator: 'Equipment Details (Simulator)',
    weatherStation: 'Equipment Details (Weather Station)',
    oplog: 'Oplog',
    systemOperation: 'System Operation',
    flightOperation: 'Flight Operation',
    productAftersale: 'Product after-sales',
    modelDataManagement: '3D data fusion platform',
    positioning3Ddata: '3D data positioning',
}